import { getQuery } from 'client/utils/location';
import { get } from 'lodash-es';

export const LEASE_PAYMENT_DATA_PATH = 'prices.estimateLeasePromise.monthlyPayment';

export function isLeaseEnabled(location) {
  const query = getQuery(location);

  return get(query, 'paymenttype', '') === 'lease';
}
